import script from "./HeroLanding.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroLanding.vue?vue&type=script&setup=true&lang=ts"

import "./HeroLanding.vue?vue&type=style&index=0&id=0d4befce&lang=scss"

const __exports__ = script;

export default __exports__